import {DefaultPageProps} from "@models/DefaultProps.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {useEffect, useState} from "react";
import {IReferenciaLink} from "@components/solicitacoes/dto/models/IReferenciaLink.ts";
import {useSolicitacao} from "@components/solicitacoes/hooks/useSolicitacao.tsx";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {SolicitacaoItemRefInfoRow} from "@components/solicitacoes/itens/RefLink/SolicitacaoItemRefInfoRow.tsx";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {CreateRefLinkComponent} from "@components/solicitacoes/itens/RefLink/CreateRefLinkComponent.tsx";

interface SolicitacaoReferenciasPageProps extends DefaultPageProps<{ idItem: number }> {
}

export function SolicitacaoReferenciasPage(props: SolicitacaoReferenciasPageProps) {
    const {getReferenciasItens} = useSolicitacao()
    const {addPopUp, closePopUp} = useAlert()
    const [values, setValues] = useState<IReferenciaLink[]>([])
    const [pagination, setPagination] = useState<IPagination>({page: 1, pageSize: 10})
    const [filters, setFilters] = useState<{ idItem: number } | undefined>()

    useEffect(() => {
        if (props.filtersProps?.filters == null) return;
        setFilters(props.filtersProps.filters)

    }, [props.filtersProps?.filters]);

    useEffect(() => {
        if (props.pageProps?.pagination == null) return;
        setPagination(props.pageProps.pagination)

    }, [props.pageProps?.pagination]);

    useEffect(() => {
        if (props.pageProps?.setPagination == null) return;
        props.pageProps.setPagination(pagination)
    }, [pagination]);

    useEffect(() => {
        if (props.filtersProps?.setFilters == null) return;
        if (filters == null) return;

        props.filtersProps.setFilters(filters)
    }, [filters]);

    useEffect(() => {
        setPagination(prev => ({...prev, page: 0}))
    }, [filters]);

    useEffect(() => {
        if (filters == null) return;
        if (pagination.page <= 0) {
            setPagination(prev => ({...prev, page: 1}))
            return
        }

        setPagination(prev => ({...prev, loading: true}));
        getReferenciasItens({data: {idItem: filters?.idItem}, pagination: pagination}).then(x => {
            if (x.hasData) {
                setValues(x.items)
                setPagination(prev => ({...prev, ...x.pagination, page: pagination.page}))
            }
        }).finally(() => {
            setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
        })

    }, [pagination.page, pagination.ignoreCache == true, filters])


    return (
        <DefaultContainer hideHeader={props.hideHeader}
                          titulo={'Referências'}
                          UpperComponent={<Grid container justifyContent={'space-between'} size={12}>
                              <Grid></Grid>
                              <Grid>
                                  <Button disabled={filters?.idItem == null} onClick={() => {
                                      if (filters?.idItem != null)
                                          addPopUp({
                                              title: 'Adicionando referencia',
                                              content: <CreateRefLinkComponent itemId={filters?.idItem}
                                                                               onCreate={() => closePopUp()}/>
                                          })
                                  }}>Adicionar referencia</Button>
                              </Grid>
                          </Grid>}
                          pageProps={{pagination, setPagination}}>
            <TableContainer>
                <Table size={'small'} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Descrição</TableCell>
                            <TableCell>Link</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.map(x => <SolicitacaoItemRefInfoRow key={x.id} value={x}/>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </DefaultContainer>)
}